export default {
  methods: {
    /**
     * Activates the click blocker overlay and executes a callback after a delay.
     * This prevents accidental clicks during dialog transitions.
     * 
     * @param {Function} callback - Function to execute after the blocker is active
     * @param {Number} delay - Delay in milliseconds before executing callback (default: 200)
     */
    activateClickBlocker (callback, delay = 200) {
      // Emit global event to activate the click blocker overlay
      this.$root.$emit('fullscreen-dialog-start-closing')
      
      // Execute callback after ensuring blocker is active
      this.$nextTick(() => {
        if (delay > 0) {
          setTimeout(callback, delay)
        } else {
          callback()
        }
      })
    },
  },
}

